// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2HNtS","toggleWrap":"styles_toggleWrap__3yr9j","content":"styles_content__3XBWD","selectAreaCode":"styles_selectAreaCode__2uxjA"};